module.exports = __webpack_public_path__ + "img/internet.34e98b93.png";